import React from 'react'
import Ad from 'scripts/components/ad'

class TakeoverAd extends React.Component {
  takeover = {
    className: 'takeover-container',
    desktop: { id: '1531819855357-0', slot: 'Desktop.Home.EN.Skin.1x1', width: 1, height: 1 },
    mobile: { id: '1532404789173-0', slot: 'MW.EN.Skin.1x1', width: 1, height: 1 }
  }

  render() {
    return (
      <Ad {...this.takeover} outofpage={true} />
    )
  }
}

export default TakeoverAd



// WEBPACK FOOTER //
// ./assets/js/components/TakeoverAd.jsx